import cn from 'classnames';
import styles from './EntertainmentStatusBadge.module.scss';
import { useTranslation } from 'react-i18next';
import { translateEntertainmentStatus } from '~/utils/translateOptions';

interface IEntertainmentStatusBadgeProps {
  status: {
    id: number;
    name: string;
    type: string;
  };
}

const EntertainmentStatusBadge = ({
  status,
}: IEntertainmentStatusBadgeProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        styles.entertainmentStatusBadge,
        status.type === 'active' || status.type === 'default'
          ? styles.entertainmentStatusBadgeActive
          : status.type === 'inactive'
            ? styles.entertainmentStatusBadgeInactive
            : styles.entertainmentStatusBadgeFull
      )}
    >
      {translateEntertainmentStatus(status.type, t)}
    </div>
  );
};

export default EntertainmentStatusBadge;
